

import React, { useState } from "react";
import { Form, Input, Button, DatePicker, TimePicker, message } from "antd";
import CommonService from "../../services/CommonService";

const ContactForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        userId: 0,
        name: values.name,
        email: values.email,
        mobile: values.phone,
        date: values.date.format("YYYY-MM-DD"),
        time: values.time.format("HH:mm"),
        dEscription: values.message,
      };

      const response = await CommonService.sendAppointment(payload);

      if (response?.status === 200 || response?.status === 201) {
        message.success("Appointment submitted successfully");
        form.resetFields();
      }
    } catch (error) {
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    message.error("Please fill all required fields");
  };

  return (
    <section className="contact-section home appointment-form">
      <div className="container">
        <div className="contact-form default-form mt-0">
          <div className="row">
            <div className="col-lg-7 col-md-8 offset-lg-5 offset-md-4 appointment-form">
              <Form
                className="content-column"
                form={form}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                // validateTrigger="onSubmit"
              >
                <div className="sec-title">
                  <div className="title">Make Appointment</div>
                  <h1>Get Free Consultation</h1>
                </div>

                <div className="row">
                  {/* Name */}
                  <div className="col-lg-6">
                    <Form.Item
                      className="row-input"
                      name="name"
                      rules={[{ required: true, message: "Name is required." }]}
                    >
                      <Input placeholder="Your Name*" />
                    </Form.Item>
                  </div>

                  {/* Email */}
                  <div className="col-lg-6">
                    <Form.Item
                      className="row-input"
                      name="email"
                      rules={[
                        { required: true, message: "Email is required." },
                        { type: "email", message: "Enter valid email address." },
                      ]}
                    >
                      <Input placeholder="Email Address*" />
                    </Form.Item>
                  </div>

                  {/* Phone */}
                  <div className="col-lg-6">
                    <Form.Item
                      className="row-input"
                      name="phone"
                      rules={[
                        { required: true, message: "Phone number is required." },
                        {
                          pattern: /^[0-9]{10}$/,
                          message: "Enter valid 10 digit phone number",
                        },
                      ]}
                    >
                      <Input placeholder="Phone No*" maxLength={10} />
                    </Form.Item>
                  </div>

                  {/* Date */}
                  <div className="col-lg-6">
                    <Form.Item
                      className="row-input"
                      name="date"
                      rules={[
                        { required: true, message: "Appointment date is required." },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%", background: "#f6f6f6" }}
                        placeholder="Appointment Date*"
                      />
                    </Form.Item>
                  </div>

                  {/* Message */}
                  <div className="col-lg-6">
                    <Form.Item
                      className="row-input"
                      name="message"
                      rules={[
                        { required: true, message: "Message is required." },
                      ]}
                    >
                      <Input.TextArea
                        rows={4}
                        style={{ height: "156px" }}
                        placeholder="Message Here*"
                      />
                    </Form.Item>
                  </div>

                  {/* Time */}
                  <div className="col-lg-6">
                    <Form.Item
                      className="row-input"
                      name="time"
                      rules={[
                        { required: true, message: "Appointment time is required." },
                      ]}
                    >
                      <TimePicker
                        style={{ width: "100%", background: "#f6f6f6" }}
                        placeholder="Appointment Time*"
                        format="HH:mm"
                      />
                    </Form.Item>
                  </div>



                  <div>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        className="btn-submit dark"
                      >
                        Get Appointment
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
